import React from 'react';
import { Grid } from '@mui/material';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import EventIcon from '@mui/icons-material/Event';
import { Section, InfoField, formatDate } from '../ViewPatientDialog.utils';

export default function HealthTab({ patient }) {
  const fiche = patient?.fiche_patient;

  return (
    <>
      <Section icon={<MedicalInformationIcon />} title="Situation médicale" subtitle="Informations générales relatives à la santé">
        <Grid container spacing={2}>
          <InfoField label="Pathologie" value={patient.pathologie_patient} fullWidth multiline />
          <InfoField label="Date d'entretien" value={fiche?.date_entretien ? formatDate(fiche.date_entretien) : null} icon={<EventIcon fontSize="small" />} />
          <InfoField label="Pratique / Coordination" value={fiche?.pratique_ou_coordination} />
          <InfoField label="Coordinatrices" value={fiche?.coordinatrices} />
        </Grid>
      </Section>

      <Section icon={<HealthAndSafetyIcon />} title="Parcours de santé et maladie" subtitle="Origine, déroulement, suivi et état de santé">
        <Grid container spacing={2}>
          <InfoField label="Origine probable décrite" value={fiche?.origine_probable_decrite} fullWidth multiline />
          <InfoField label="Déroulé du cancer" value={fiche?.deroule_cancer} fullWidth multiline />
          <InfoField label="Corps médical" value={fiche?.corps_medical} fullWidth multiline />
          <InfoField label="État de santé aujourd'hui" value={fiche?.etat_sante_aujourd_hui} fullWidth multiline />
          <InfoField label="Effets indésirables physiques" value={fiche?.effets_indesirables_physique} fullWidth multiline />
          <InfoField label="Effets indésirables psycho-émotionnels" value={fiche?.effets_indesirables_psy_emo} fullWidth multiline />
          <InfoField label="Analyse médicale" value={fiche?.analyse_medicale} fullWidth multiline />
        </Grid>
      </Section>

      <Section icon={<MedicalInformationIcon />} title="Traitements" subtitle="Traitements allopathiques et alternatifs">
        <Grid container spacing={2}>
          <InfoField label="Traitement allopathique" value={fiche?.traitement_allopathique} fullWidth multiline />
          <InfoField label="Traitement alternatif" value={fiche?.traitement_alternatif} fullWidth multiline />
          <InfoField label="Allergies" value={fiche?.allergies} fullWidth multiline />
        </Grid>
      </Section>
    </>
  );
}